import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryBaseResources (params) {
  return request({
    ...APIS['@resourceSetting/Query_Base_Resources'],
    params
  })
}

//
export function queryResourcePack (params) {
  return request({
    ...APIS['@resourceSetting/Query_ResourcePack'],
    params
  })
}
// 配置资源
export function configureResourcePack (data) {
  return request({
    ...APIS['@resourceSetting/Configure_ResourcePack'],
    data
  })
}

export function addResource (data) {
  return request({
    ...APIS['@resourceSetting/Add_Resource'],
    data
  })
}
// 查看资源变更记录
export function queryResourceChange (params) {
  return request({
    ...APIS['@resourceSetting/Query_ResourceChange'],
    params
  })
}

export function checkProductTypeDelete (params) {
  return request({
    ...APIS['@resourceSetting/Check_ProductTypeDelete'],
    params
  })
}

export function checkResourceDelete (params) {
  return request({
    ...APIS['@resourceSetting/Check_ResourceDelete'],
    params
  })
}

export function exportBaseDetails (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@resourceSetting/Export_BaseDetails'],
    params,
    headers,
    responseType
  })
}
